import React, { useState } from 'react';
import { MdCheck, MdCopyAll, MdCopyright } from 'react-icons/md';

const CopyButton = ({ textToCopy }: {textToCopy: string}) => {
  const [copied, setCopied] = useState('');

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(textToCopy);
      setCopied(textToCopy);
      setTimeout(() => setCopied(''), 2000);
    } catch (error) {
      console.error('Failed to copy text: ', error);
    }
  };

  const isCopied = textToCopy === copied;
  return (
      <button
        onClick={handleCopy}
      >
        {!isCopied ? <MdCopyAll /> : <MdCheck />}
      </button>
  );
};

export default CopyButton;
